import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IFeature } from "../shared/interfaces";
import { Can } from "@casl/react";

const controller = 'Features';


const getFeatures = (cancelToken?: CancelToken): Promise<IFeature[]> => {
    return axiosInstance.get(`${controller}/GetFeatures`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateFeatures = (features: IFeature[], cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.put(`${controller}/UpdateFeatures`, features, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const canActivateFeature = (featureKey: string, cancelToken?: CancelToken): Promise<boolean> => {
    return axiosInstance.get(`${controller}/CanActivateFeature`, { cancelToken: cancelToken, params: { featureKey: featureKey } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    getFeatures,
    updateFeatures,
    canActivateFeature
}